import { api } from "../../util";

export const getExpensesApiCall = (payload = {}) => {
  let url = "/expenses";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      //   search: payload.search,
    },
  });
};
